(function () {
  'use strict';

  var FLIP_DELAY_MS = 1000;
  var FLIP_TRANSITION_MS = 700;
  var HOVER_SUPPRESS_MS = 450;
  var listenersAttached = false;
  var variantHandlersStarted = false;
  var variantBFlipTimerIds = [];

  function isVariantA() {
    return document.body.classList.contains('kameleoon-kpro-gallery-a');
  }

  function isVariantB() {
    return document.body.classList.contains('kameleoon-kpro-gallery-b');
  }

  function isActive() {
    return isVariantA() || isVariantB();
  }

  function isMobileGalleryViewport() {
    return window.matchMedia('(max-width: 776px)').matches;
  }

  function getMainGalleries() {
    return Array.from(document.querySelectorAll('media-gallery')).filter(function (gallery) {
      return !String(gallery.id || '').endsWith('-duplicate');
    });
  }

  function clearVariantBFlipTimers() {
    variantBFlipTimerIds.forEach(function (timerId) {
      window.clearTimeout(timerId);
    });
    variantBFlipTimerIds = [];
  }

  function scheduleVariantBTimer(callback, delay) {
    variantBFlipTimerIds.push(window.setTimeout(callback, delay));
  }

  function suppressThumbHover(duration) {
    document.body.classList.add('kpro-ab-suppress-thumb-hover');
    window.setTimeout(function () {
      document.body.classList.remove('kpro-ab-suppress-thumb-hover');
    }, duration || HOVER_SUPPRESS_MS);
  }

  function getCurrentVariantId() {
    var radio = document.querySelector('input[name="Kapseln"]:checked');
    if (radio && radio.getAttribute('input-variant-id')) {
      return radio.getAttribute('input-variant-id');
    }

    var formInput =
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form[id^="product-form-"] input[name="id"]');
    if (formInput && formInput.value) return formInput.value;

    return null;
  }

  function getVariantById(variantId) {
    var picker = document.querySelector('variant-radios');
    if (!picker) return null;
    var script = picker.querySelector('script[type="application/json"]');
    if (!script || !script.textContent) return null;

    try {
      var variants = JSON.parse(script.textContent);
      return variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      });
    } catch (error) {
      return null;
    }
  }

  function copyImageAttributes(targetImg, sourceImg) {
    if (!targetImg || !sourceImg) return;
    targetImg.src = sourceImg.currentSrc || sourceImg.src;
    if (sourceImg.srcset) targetImg.srcset = sourceImg.srcset;
    if (sourceImg.sizes) targetImg.sizes = sourceImg.sizes;
  }

  function findHiddenVariationThumb(gallery, variantId) {
    var sourceThumb = null;
    gallery.querySelectorAll('.thumbnail-list__item[data-variation-id="' + variantId + '"]').forEach(function (el) {
      if (
        !el.classList.contains('kpro-ab-packshot-thumb') &&
        !el.classList.contains('kpro-ab-gallery-thumb')
      ) {
        sourceThumb = el;
      }
    });
    return sourceThumb;
  }

  function findPackshotSlide(gallery, featuredMediaId) {
    if (!featuredMediaId) return null;
    return (
      gallery.querySelector(
        '.product__media-item.Packshot[data-media-id$="-' + featuredMediaId + '"]'
      ) || gallery.querySelector('.product__media-item[data-media-id$="-' + featuredMediaId + '"]')
    );
  }

  function syncPackshotThumbInGallery(gallery, variantId) {
    var packshotThumb = gallery.querySelector('.kpro-ab-packshot-thumb');
    if (!packshotThumb || !variantId) return;

    var sourceThumb = findHiddenVariationThumb(gallery, variantId);
    var packshotImg = packshotThumb.querySelector('img');

    if (sourceThumb) {
      copyImageAttributes(packshotImg, sourceThumb.querySelector('img'));
      packshotThumb.dataset.target = sourceThumb.dataset.target;
    } else {
      var variant = getVariantById(variantId);
      var featuredMediaId = variant && variant.featured_media && variant.featured_media.id;
      var slide = findPackshotSlide(gallery, featuredMediaId);
      if (slide) {
        var slideImg = slide.querySelector('.zoomable__img') || slide.querySelector('.product__media.media img');
        copyImageAttributes(packshotImg, slideImg);
        packshotThumb.dataset.target = slide.dataset.mediaId;
      }
    }

    packshotThumb.setAttribute('data-variation-id', variantId);

    gallery.querySelectorAll('.thumbnail-list__item[data-variation-id]').forEach(function (el) {
      el.classList.toggle('current', el === packshotThumb);
    });
  }

  function syncPackshotThumbs(variantId) {
    var id = variantId || getCurrentVariantId();
    if (!id) return;

    getMainGalleries().forEach(function (gallery) {
      syncPackshotThumbInGallery(gallery, id);
    });
  }

  function scrollActiveSlideIntoView(gallery, activeSlide) {
    var slide = activeSlide || gallery.querySelector('.product__media-item.is-active');
    if (!slide) return;

    var mediaList = gallery.querySelector('.product__media-list');
    if (!mediaList) return;

    gallery.dataset.kproAbSuppressSlideChanged = '1';

    window.requestAnimationFrame(function () {
      void slide.offsetWidth;
      mediaList.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });

      window.setTimeout(function () {
        delete gallery.dataset.kproAbSuppressSlideChanged;
        if (typeof gallery.updateMobileArrows === 'function') {
          gallery.updateMobileArrows(slide);
        }
      }, 250);
    });
  }

  function updateGalleryCounterForThumb(gallery, thumb) {
    if (!thumb || typeof gallery.updateCurrentImageCounter !== 'function') return;

    if (thumb.dataset.mediaPosition) {
      gallery.updateCurrentImageCounter(thumb.dataset.mediaPosition);
      return;
    }

    var slides = gallery.querySelectorAll('.product__media-item.slider__slide');
    var activeSlide = gallery.querySelector('.product__media-item.is-active');
    var index = Array.from(slides).indexOf(activeSlide);
    if (index >= 0) {
      gallery.updateCurrentImageCounter(index + 1);
    }
  }

  function activatePackshotInGallery(gallery) {
    var packshotThumb = gallery.querySelector('.kpro-ab-packshot-thumb');
    if (!packshotThumb || !packshotThumb.dataset.target) return;

    var targetId = packshotThumb.dataset.target;
    var packshotSlide = gallery.querySelector('.product__media-item[data-media-id="' + targetId + '"]');

    if (isMobileGalleryViewport() && packshotSlide) {
      gallery._activeMediaId = targetId;
      gallery.querySelectorAll('.product__media-item').forEach(function (slide) {
        slide.classList.toggle('is-active', slide.dataset.mediaId === targetId);
      });

      if (typeof gallery.setActiveThumbnail === 'function') {
        gallery.setActiveThumbnail(packshotThumb);
      }

      scrollActiveSlideIntoView(gallery, packshotSlide);
      updateGalleryCounterForThumb(gallery, packshotThumb);
      return;
    }

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(targetId, false, {
        skipAnnounce: true,
        skipPlayMedia: true,
      });
    }

    if (typeof gallery.setActiveThumbnail === 'function') {
      gallery.setActiveThumbnail(packshotThumb);
    }

    scrollActiveSlideIntoView(gallery, packshotSlide);
    updateGalleryCounterForThumb(gallery, packshotThumb);
  }

  function activateRuhmannInGallery(gallery) {
    var ruhmannThumb = gallery.querySelector('.kpro-ab-gallery-thumb');
    var ruhmannSlide = gallery.querySelector('.kpro-ab-gallery-slide');
    if (!ruhmannThumb || !ruhmannThumb.dataset.target || !ruhmannSlide) return;

    var targetId = ruhmannThumb.dataset.target;

    if (isMobileGalleryViewport()) {
      gallery._activeMediaId = targetId;
      gallery.querySelectorAll('.product__media-item').forEach(function (slide) {
        slide.classList.toggle('is-active', slide.dataset.mediaId === targetId);
      });

      if (typeof gallery.setActiveThumbnail === 'function') {
        gallery.setActiveThumbnail(ruhmannThumb);
      }

      scrollActiveSlideIntoView(gallery, ruhmannSlide);
      updateGalleryCounterForThumb(gallery, ruhmannThumb);
      return;
    }

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(targetId, false, {
        skipAnnounce: true,
        skipPlayMedia: true,
      });
    }

    if (typeof gallery.setActiveThumbnail === 'function') {
      gallery.setActiveThumbnail(ruhmannThumb);
    }

    scrollActiveSlideIntoView(gallery, ruhmannSlide);
    updateGalleryCounterForThumb(gallery, ruhmannThumb);
  }

  function restoreVariantPackshotInGallery(gallery, variantId) {
    syncPackshotThumbInGallery(gallery, variantId);
    activatePackshotInGallery(gallery);
  }

  function preparePackshotForFlip() {
    syncPackshotThumbs();
    getMainGalleries().forEach(activatePackshotInGallery);
  }

  function clearVariantBFlipState() {
    document.body.classList.remove(
      'kpro-ab-flip-pending',
      'kpro-ab-ruhmann-active',
      'kpro-ab-main-swapping',
      'kpro-ab-main-swapped'
    );
  }

  function runVariantBFirstLoadFlip() {
    if (!isVariantB()) return;

    clearVariantBFlipTimers();
    clearVariantBFlipState();
    document.body.classList.add('kpro-ab-flip-pending');
    suppressThumbHover(FLIP_DELAY_MS + FLIP_TRANSITION_MS + 300);
    preparePackshotForFlip();

    scheduleVariantBTimer(function () {
      if (!isVariantB()) return;

      document.body.classList.add('kpro-ab-main-swapping');

      scheduleVariantBTimer(function () {
        if (!isVariantB()) return;
        getMainGalleries().forEach(activateRuhmannInGallery);
        document.body.classList.remove('kpro-ab-main-swapping', 'kpro-ab-flip-pending');
        document.body.classList.add('kpro-ab-main-swapped', 'kpro-ab-ruhmann-active');

        scheduleVariantBTimer(function () {
          document.body.classList.remove('kpro-ab-main-swapped');
        }, FLIP_TRANSITION_MS);
      }, FLIP_TRANSITION_MS);
    }, FLIP_DELAY_MS);
  }

  function onVariantChange(variantId) {
    suppressThumbHover();

    window.setTimeout(function () {
      var id = variantId || getCurrentVariantId();
      if (!id) return;

      if (isVariantA()) {
        syncPackshotThumbs(id);
      }

      if (isVariantB()) {
        clearVariantBFlipTimers();
        clearVariantBFlipState();
        getMainGalleries().forEach(function (gallery) {
          restoreVariantPackshotInGallery(gallery, id);
        });
      }
    }, 250);
  }

  function attachListeners() {
    if (listenersAttached) return;
    listenersAttached = true;

    var variantPicker = document.querySelector('variant-radios') || document.querySelector('variant-selects');
    if (variantPicker) {
      variantPicker.addEventListener('change', function () {
        onVariantChange(getCurrentVariantId());
      });
    }

    document.addEventListener('change', function (event) {
      if (event.target.type === 'radio' && event.target.name === 'Kapseln') {
        onVariantChange(event.target.getAttribute('input-variant-id'));
      }
    });
  }

  function runForCurrentVariant() {
    if (isVariantA()) {
      clearVariantBFlipTimers();
      clearVariantBFlipState();
      runWhenGalleriesReady(function () {
        syncPackshotThumbs();
        getMainGalleries().forEach(function (gallery) {
          activatePackshotInGallery(gallery);
        });
      });
      return;
    }

    if (isVariantB()) {
      runWhenGalleriesReady(runVariantBFirstLoadFlip);
    }
  }

  function runWhenGalleriesReady(callback) {
    function galleriesReady() {
      var galleries = getMainGalleries();
      return (
        galleries.length > 0 &&
        galleries.every(function (gallery) {
          return gallery.isConnected && typeof gallery.setActiveMedia === 'function';
        })
      );
    }

    function start() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(callback);
      });
    }

    if (galleriesReady()) {
      start();
      return;
    }

    var attempts = 0;
    var poll = window.setInterval(function () {
      attempts += 1;
      if (galleriesReady() || attempts >= 60) {
        window.clearInterval(poll);
        start();
      }
    }, 50);
  }

  function getActiveVariantKey() {
    if (isVariantA()) return 'a';
    if (isVariantB()) return 'b';
    return null;
  }

  function watchVariantSwitch() {
    var lastVariant = getActiveVariantKey();
    var observer = new MutationObserver(function () {
      var current = getActiveVariantKey();
      if (!current || current === lastVariant) return;
      lastVariant = current;
      runForCurrentVariant();
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function startVariantHandlers() {
    if (variantHandlersStarted) return;
    variantHandlersStarted = true;
    attachListeners();
    watchVariantSwitch();
    runForCurrentVariant();
  }

  function waitForActiveVariant(callback) {
    if (isActive()) {
      callback();
      return;
    }

    var finished = false;
    function finish() {
      if (finished || !isActive()) return;
      finished = true;
      observer.disconnect();
      window.clearInterval(poll);
      callback();
    }

    var observer = new MutationObserver(finish);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    window.kameleoonQueue = window.kameleoonQueue || [];
    window.kameleoonQueue.push(finish);

    var attempts = 0;
    var poll = window.setInterval(function () {
      attempts += 1;
      if (isActive()) {
        finish();
      } else if (attempts >= 80) {
        finished = true;
        observer.disconnect();
        window.clearInterval(poll);
      }
    }, 250);
  }

  function boot() {
    waitForActiveVariant(startVariantHandlers);
  }

  function start() {
    var onReady = function () {
      boot();
    };

    if (window.Kameleoon?.API?.Core?.runWhenElementPresent) {
      window.Kameleoon.API.Core.runWhenElementPresent('[id^="MediaGallery-"]', onReady);
      return;
    }

    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('media-gallery').then(onReady).catch(onReady);
      return;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }
  }

  start();
})();
